import { authorizedAction } from 'api'
import { ErrorProp } from './'

type UpdateProgressResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type UpdateProgressProps = {
  userId?: string
  lessonNumber?: number
  partNumber?: number
}

export async function progress({
  userId,
  lessonNumber,
  partNumber,
}: UpdateProgressProps): Promise<UpdateProgressResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Student.UpdateProgress',
      body: {
        Username: userId,
        lessonNumber: lessonNumber,
        partNumber: partNumber,
      },
    })

    const json = (await response.json()) as UpdateProgressResponseProps
    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
